var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide-fade" } }, [
    _c("div", { staticClass: "l-modal-mask" }, [
      _c("div", { staticClass: "sidebar-right" }, [
        _c("div", { staticClass: "row mb-2" }, [
          _c("div", { staticClass: "col" }, [
            _c("h1", { staticClass: "modal-h1 mb-3" }, [
              _c("button", {
                staticClass: "btn btn-back",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    _vm.$emit("closeModal")
                  }
                }
              }),
              _vm._v("\n            New claim\n          ")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "row mb-2" }, [
            _c(
              "div",
              { staticClass: "col pr-1" },
              [
                _c(
                  "div",
                  { staticClass: "select-wrap" },
                  [
                    _c("label", [_vm._v("Claim type:")]),
                    _vm._v(" "),
                    _c("simple-select", {
                      attrs: {
                        options: _vm.claimTypes,
                        placeholder: "Select type"
                      },
                      on: {
                        input: function($event) {
                          _vm.errors.clear("claim_type_id")
                        }
                      },
                      model: {
                        value: _vm.claim.claim_type_id,
                        callback: function($$v) {
                          _vm.$set(_vm.claim, "claim_type_id", $$v)
                        },
                        expression: "claim.claim_type_id"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "claim_type_id" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col pl-1 pr-1" },
              [
                _c(
                  "div",
                  { staticClass: "select-wrap" },
                  [
                    _c("label", [_vm._v("Claim priority:")]),
                    _vm._v(" "),
                    _c("simple-select", {
                      attrs: {
                        options: _vm.claimPriorities,
                        "track-by": "id",
                        placeholder: "Medium"
                      },
                      model: {
                        value: _vm.claim.claim_priority_id,
                        callback: function($$v) {
                          _vm.$set(_vm.claim, "claim_priority_id", $$v)
                        },
                        expression: "claim.claim_priority_id"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "claim_priority_id" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mb-2" }, [
            _c(
              "div",
              { staticClass: "col pr-1" },
              [
                _c("div", { staticClass: "select-wrap" }, [
                  _c("label", [_vm._v("Claim title:")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.claim.title,
                        expression: "claim.title"
                      }
                    ],
                    ref: "title",
                    staticClass: "form-control",
                    attrs: { type: "text", autocomplete: "no" },
                    domProps: { value: _vm.claim.title },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.claim, "title", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "title" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mb-2" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _c("div", { staticClass: "select-wrap h-auto" }, [
                  _c("label", [_vm._v("Claim description:")]),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.claim.description,
                        expression: "claim.description"
                      }
                    ],
                    ref: "description",
                    staticClass: "select-wrap-textarea form-control",
                    attrs: { rows: "5" },
                    domProps: { value: _vm.claim.description },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.claim, "description", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "description" }
                })
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _vm.$_can("claims.assign")
          ? _c("div", { staticClass: "row mb-2" }, [
              _c(
                "div",
                { staticClass: "col pr-1" },
                [
                  _c(
                    "div",
                    { staticClass: "select-wrap" },
                    [
                      _c("label", [_vm._v("Assign claim:")]),
                      _vm._v(" "),
                      _c("simple-select", {
                        attrs: {
                          placeholder: "Select agent",
                          options: _vm.claimsUsers,
                          "custom-label": _vm.customLabel
                        },
                        model: {
                          value: _vm.claim.cluster_user_id,
                          callback: function($$v) {
                            _vm.$set(_vm.claim, "cluster_user_id", $$v)
                          },
                          expression: "claim.cluster_user_id"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "cluster_user_id" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col pl-1 pr-1" })
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "row w-100 job-buttons position-absolute" }, [
          _c("div", { staticClass: "col-12 py-2 border-top text-right" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    _vm.$emit("closeModal")
                  }
                }
              },
              [_vm._v("\n            Cancel\n          ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary ld-ext-right",
                class: _vm.loadingButton ? "running" : "",
                attrs: { type: "button", disabled: _vm.buttonDisabled },
                on: { click: _vm.createClaim }
              },
              [
                _vm._v("\n            Save\n            "),
                _c("div", { staticClass: "ld ld-ball ld-flip" })
              ]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ed09d22", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ed09d22","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/claims/Modals/CreateClaim.vue
// module id = null
// module chunks = 